import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { Elixir } from '../components/elixir'
import { Field } from '../components/field'

export const CardQuery = graphql`
  query CardQuery {
    a_royaleclash {
      cards {
        id
        fullName
        imageSmall
        arena
        elixir
        rarity
        type
        level
        damageA
        hitpointsA
        hitpointsB
        arena
        buildingHitpoints
        chainedAttackA
        chargeDamageA
        countA
        countC
        damageA
        damageTowerA
        dashRangeStartA
        deathDamageA
        deployTime
        dpsA
        hitSpeedA
        level
        imageSmall
        movementSpeedA
        type
        shieldHitpointsA
        rarity
        description

        # areaDmgA
        targetsBuildingsA
        targetsGroundA
        targetsAirA
        spawnSpeed
        lifetime
      }
      icons {
        id
        name
        img
        label
      }
    }
  }
`

const showCardDetails = ({ card }) => {

  return (
    <div className="modelInfo">
      <div className="column max">
        <div className="headerContainer">
          <Elixir count={card.elixir} />
          <img className="imageSmallField" src={card.imageSmall} alt={card.imageSmall} />
          <div className="nameLevelRarityType">
            <h1 className="fullNameField">{card.fullName}</h1>
            <div className={`levelField level ${card.rarity}2`}>Level {card.level}</div>
            <div className="roww flex near">
              <div className="column short m3 flex1">
                <span className={`round level ${card.rarity}`}>Rarity</span>
                <div className={`round level ${card.rarity}2`}>{card.rarity}</div>
              </div>
              <div className="column short m3 flex1">
                <span className={`round level ${card.rarity}`}>Type</span>
                <div className={`round level ${card.rarity}2`}>{card.type}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="boardContainer">
          <div className="modalInfoColumn">
            {card.damageA ? <Field field="Damage" img="damage.png" info={card.damageA} /> : null}
            {card.hitpointsA ? <Field field="Hitpoints" img="hitpoints.png" info={card.hitpointsA} /> : null}
            {card.targetsAirA === 1 && card.targetsGroundA === 1 && card.targetsBuildingsA === 1 ? <Field field="Targets" img="target.png" info={"Air, Ground & Building"} /> : null}
            {card.targetsAirA === 1 && card.targetsGroundA === 1 && card.targetsBuildingsA === 0 ? <Field field="Targets" img="target.png" info={"Air & Ground"} /> : null}
            {card.targetsAirA === 1 && card.targetsGroundA === 0 && card.targetsBuildingsA === 1 ? <Field field="Targets" img="target.png" info={"Air & Building"} /> : null}
            {card.targetsAirA === 0 && card.targetsGroundA === 1 && card.targetsBuildingsA === 1 ? <Field field="Targets" img="target.png" info={"Ground & Building"} /> : null}
            {card.targetsAirA === 1 && card.targetsGroundA === 0 && card.targetsBuildingsA === 0 ? <Field field="Targets" img="target.png" info={"Air"} /> : null}
            {card.targetsAirA === 0 && card.targetsGroundA === 1 && card.targetsBuildingsA === 0 ? <Field field="Targets" img="target.png" info={"Ground"} /> : null}
            {card.targetsAirA === 0 && card.targetsGroundA === 0 && card.targetsBuildingsA === 1 ? <Field field="Targets" img="target.png" info={"Building"} /> : null}
            {card.countA !== 1 ? <Field field="Count" img="count.png" info={card.countA} /> : null}
            {card.spawnSpeed ? <Field field="Spawn Speed" img="duration-lifetime.png" info={card.spawnSpeed} /> : null}
            {card.deployTime !== 1 ? <Field field="Deploy Time" img="deploy-time.png" info={card.deployTime} /> : null}
            {card.fullName === "Mirror" ? <>
              <Field field="Common Level" img="cards.png" info={card.level} />
              <Field field="Epic Level" img="cards.png" info={card.level} />
            </> : null}
          </div>
          <div className="modalInfoColumn">
            {card.dpsA ? <Field field="Damage Per Second" img="damagepersec.png" info={card.dpsA} /> : null}
            {card.hitSpeedA === 1 ? <Field field="Hit Speed" img="hit-speed.png" info="Slow" /> : null}
            {card.hitSpeedA === 2 ? <Field field="Hit Speed" img="hit-speed.png" info="Medium" /> : null}
            {card.hitSpeedA === 3 ? <Field field="Hit Speed" img="hit-speed.png" info="Fast" /> : null}
            {card.hitSpeedA === 4 ? <Field field="Hit Speed" img="hit-speed.png" info="Very Fast" /> : null}
            {card.movementSpeedA === 1 ? <Field field="Speed" img="speed.png" info="Slow" /> : null}
            {card.movementSpeedA === 2 ? <Field field="Speed" img="speed.png" info="Medium" /> : null}
            {card.movementSpeedA === 3 ? <Field field="Speed" img="speed.png" info="Fast" /> : null}
            {card.movementSpeedA === 4 ? <Field field="Speed" img="speed.png" info="Very Fast" /> : null}
            {/* {card.type ? <Field field="Type" img="troop.png" info={card.type} /> : null} */}
            {card.level && card.fullNameB ? <Field field="Level" img="count.png" info={card.fullNameB + ' ' + card.level} /> : null}
            {/* {card.level && !card.fullNameB ? <Field field="Level" img="count.png" info={card.level} /> : null} */}
            {card.shieldHitpointsA ? <Field field="Shield Hitpoints" img="shield-hitpoints.png" info={card.shieldHitpointsA} /> : null}
            {card.dashRangeStartA ? <Field field="Dash" img="charge.png" info={card.dashRangeStartA} /> : null}
            {card.deathDamageA ? <Field field="Death Damage" img="death-damage.png" info={card.deathDamageA} /> : null}
            {card.lifetime ? <Field field="Lifetime" img="duration-lifetime.png" info={card.lifetime} /> : null}
            {/* <Field field="Dash" img="charge-start.png" info={card.dashRangeStartA} /> */}
            {/* <Field field="arena" img="arena.png" info={card.arena} /> */}
            {/* <Field field="buildingHitpoints" img="buildingHitpoints.png" info={card.buildingHitpoints} /> */}
            {/* <Field field="chainedAttackA" img="chainedAttackA.png" info={card.chainedAttackA} /> */}
            {/* <Field field="chargeDamageA" img="chargeDamageA.png" info={card.chargeDamageA} /> */}
            {/* <Field field="Damage" img="damageTowerA.png" info={card.damageTowerA} /> */}
            {/* duration-lifetime.png */}
            {/* target.png */}
            {/* stun-freeze.png */}
            {/* range.png */}
            {/* radius.png */}
            {/* dash-range.png */}
            {/* level.png */}
            {/* boost-rage.png */}
            {/* cards.png */}
            {card.fullName === "Mirror" ? <>
              <Field field="Rare Level" img="cards.png" info={card.level} />
              <Field field="Legendary Level" img="cards.png" info={card.level} />
            </> : null}
          </div>
        </div>
        <div className="descriptionContainer m3">
          <div className="description grey m3 round">
            {card.description ? card.description : null}
          </div>
        </div>
        <div className="center column videoContainer">
          <video className="video media" id="giantGif" alt="gif" loop
            height="100%" width="100%" autoPlay playsInline preload="auto" poster="https://thumbs.gfycat.com/BabyishPerfectAntbear-mobile.jpg" tabindex="-1"
            style={{ maxWidth: '640px', margin: '0px auto, display: block' }}>
            <track src="subtitle.vtt" kind="captions" srclang="en" label="english_captions" />
            <source src="https://thumbs.gfycat.com/BabyishPerfectAntbear-mobile.mp4" type="video/mp4" />
            <source src="https://giant.gfycat.com/BabyishPerfectAntbear.webm" type="video/webm" />
            <source src="https://giant.gfycat.com/BabyishPerfectAntbear.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
    </div >
  )
}

const Card = (card) => {
  const [cardDetails, setCardDetails] = React.useState(false);

  React.useEffect(() => {
    if (window && window.screen.width !== 0) {
      window.scrollTo(0, 0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [(card) => toggleCardDetails(card)])

  const toggleCardDetails = (card) => {
    cardDetails ? setCardDetails(false) : setCardDetails(true)
    return card
  }

  return (
    <div className="card" onClick={() => toggleCardDetails(card)} onKeyDown={() => null} tabIndex={-42} role="button">
      <Elixir count={card.card.elixir} />
      <img className="cardImage" src={card.card.imageSmall} alt={card.card.imageSmall} />
      <div className={`level ${card.card.rarity} offset`}>
        {card.card.level === 13 ? card.card.level && "Max Level" : "Level " + card.card.level}
      </div>
      <div className="max"> {cardDetails ? showCardDetails(card) : null}</div>
    </div>
  )
}

const Cards = ({ data }) => {
  return (
    <Layout>
      <SEO title="Cards" />
      <div className="cards">
        {data.a_royaleclash.cards.map((card) => <Card card={card} icons={data.a_royaleclash.icons} key={card.id} />)}
      </div>
    </Layout>
  )
}

export default Cards
